import {instance} from "../lib/request";

function get(options) {
    return instance.get('/api/web/shop/get',{
        params: options,
    });
}


export default {
    get
}
